import React from 'react';

import { IconAudioPlayer } from './icon-audio-player';
import { useSoundContext } from '../../hooks/use-sound-context';
import type { ColorsType } from '../../interfaces/colors.type';
import type { FontSizeType } from '../../interfaces/fonts.type';

export interface IconAudioWithContextProps {
  active?: boolean;
  text: string;
  fontSize?: FontSizeType;
  color?: keyof ColorsType;
  onReproduce?: () => void;
}

export const IconAudioPlayerWithContext: React.FC<IconAudioWithContextProps> = (
  props
) => {
  const sound = useSoundContext();

  return <IconAudioPlayer {...props} sound={sound} />;
};
